import {
    ToggleButton,
    ToggleButtonGroup,
    styled,
} from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 40

const buttonStyle = (theme) => ({
    borderRadius: theme.spacing(50),
    border: `1px solid ${theme.palette.primary.contrastText}`,
    minWidth: 56,

    "&.Mui-disabled": {
        color: theme.palette["_components/app-bar/button/disabled"].contrastText,
        backgroundColor: theme.palette["_components/app-bar/button/disabled"].main,
        border: `1px dashed ${theme.palette["_components/app-bar/button/disabled"].contrastText}`,
    },
})

export const Container = styled(ToggleButtonGroup)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(6),
    alignItems: "flex-start",
    flexGrow: 1,

    "& .MuiToggleButtonGroup-firstButton": buttonStyle(theme),
    "& .MuiToggleButtonGroup-middleButton": buttonStyle(theme),
    "& .MuiToggleButtonGroup-lastButton": buttonStyle(theme),
}))

export const AppButton = styled(ToggleButton)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
    gap: theme.spacing(1),
    height: BUTTON_SIZE,

    "&.Mui-selected": {
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette["_components/app-bar/button/default"].dark}`,
        backgroundColor: theme.palette["_components/app-bar/button/default"].dark,

        "&:hover": {
            border: `1px solid ${theme.palette["_components/app-bar/button/default"].dark}`,
            backgroundColor: theme.palette["_components/app-bar/button/default"].dark,
        },
    },

    "&:hover": {
        backgroundColor: theme.palette["_components/app-bar/button/default"].dark,
        border: `1px solid ${theme.palette["_components/app-bar/button/default"].dark}`,
    },

    ...theme.typography.Regular,
}))

export const ModulesContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(6),
    marginLeft: "auto",
}))

export const ModuleButton = styled(ToggleButton)(({ theme }) => ({
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    minWidth: `${BUTTON_SIZE}px !important`,
    border: `1px solid ${theme.palette.primary.contrastText}`,
    color: theme.palette.primary.contrastText,

    "&.Mui-selected": {
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette["_components/app-bar/button/default"].dark}`,
        backgroundColor: theme.palette["_components/app-bar/button/default"].dark,

        "&:hover": {
            border: `1px solid ${theme.palette["_components/app-bar/button/default"].dark}`,
            backgroundColor: theme.palette["_components/app-bar/button/default"].dark,
        },
    },

    "&:hover": {
        backgroundColor: theme.palette["_components/app-bar/button/default"].dark,
        border: `1px solid ${theme.palette["_components/app-bar/button/default"].dark}`,
    },
}))